import { gql } from '@apollo/client'
import { MilestoneFragments } from '../fragments/milestone.fragments'
import { NoteFragment } from '../fragments/note.fragment'
import { ProjectItemFragments } from '../fragments/projectItem.fragments'
export const CreateProjectMutation = gql`
    mutation createProject($createProjectInput: ProjectInput!) {
        createProject(input: $createProjectInput) {
            project {
                budget
                firmId
                id
                imageUrl
                name
            }
            startBackendProcessResult {
                instanceId
            }
        }
    }
`
export const UpdateProjectMutation = gql`
    mutation updateProject($updateProjectInput: ProjectInput!) {
        updateProject(input: $updateProjectInput) {
            budget
            firmId
            id
            imageUrl
            name
        }
    }
`
export const UpdateProjectTeamMutation = gql`
    mutation updateProjectTeam($updateProjectTeamInput: ProjectTeamInput!) {
        updateProjectTeam(input: $updateProjectTeamInput) {
            ...projectTeam
        }
    }
    ${ProjectItemFragments.ProjectTeam}
`

export const UpdateProjectTeamAssignmentMutation = gql`
    mutation updateProjectTeamAssignment(
        $updateAssignmentDataInput: UpdateAssignmentDataInput!
    ) {
        updateProjectTeamAssignment(input: $updateAssignmentDataInput) {
            description
            projectRole
            user {
                id
            }
        }
    }
`
export const UploadProjectImageMutation = gql`
    mutation uploadProjectImage($uploadInput: UploadProjectImageInput!) {
        uploadProjectImage(input: $uploadInput) {
            id
            imageUrl
        }
    }
`

export const ResetProjectImageMutation = gql`
    mutation resetProjectImage($resetProjectInput: ResetProjectImageInput!) {
        resetProjectImage(input: $resetProjectInput) {
            id
            imageUrl
        }
    }
`

export const AddProjectToRecentlyVisitedMutation = gql`
    mutation addProjectToRecentlyVisited($input: UserProjectMutationInput!) {
        addProjectToRecentlyVisited(input: $input)
    }
`
export const CreateProjectNoteMutation = gql`
    mutation createProjectNote(
        $createProjectNoteInput: CreateProjectNoteInput!
    ) {
        createProjectNote(input: $createProjectNoteInput) {
            ...noteFragment
        }
    }
    ${NoteFragment}
`
export const UpdateProjectNoteMutation = gql`
    mutation updateProjectNote(
        $updateProjectNoteInput: UpdateProjectNoteInput!
    ) {
        updateProjectNote(input: $updateProjectNoteInput) {
            ...noteFragment
        }
    }
    ${NoteFragment}
`
export const SetProjectNoteStateMutation = gql`
    mutation setProjectNoteState(
        $setProjectNoteStateInput: SetProjectNoteStateInput!
    ) {
        setProjectNoteState(input: $setProjectNoteStateInput) {
            ...noteFragment
        }
    }
    ${NoteFragment}
`
export const AddProjectNoteComment = gql`
    mutation addProjectComment(
        $addProjectCommentInput: AddProjectNoteCommentInput!
    ) {
        addProjectComment(input: $addProjectCommentInput) {
            dataType
            firmId
            id
            metadata {
                creatorId
            }
            partitionKey
            projectId
            projectNoteId
            shouldSerializeFirmId
            shouldSerializePartitionKey
            siteId
            text
        }
    }
`
export const RemoveProjectNoteComment = gql`
    mutation removeProjectComment(
        $removeProjectCommentInput: RemoveProjectCommentInput!
    ) {
        removeProjectComment(input: $removeProjectCommentInput)
    }
`

export const UpdateProjectSettings = gql`
    mutation setProjectSettings($input: ProjectSettingsInput!) {
        setProjectSettings(input: $input) {
            projectSettings {
                collectData
                familyNumberFormat
                unitOfMeasure
                elementTreeView
            }
        }
    }
`

export const RemoveProjectNote = gql`
    mutation removeProjectNote(
        $removeProjectNoteInput: RemoveProjectNoteInput!
    ) {
        removeProjectNote(input: $removeProjectNoteInput)
    }
`
export const UpdateProjectMilestone = gql`
    mutation setProjectMilestone(
        $projectMilestoneInput: ProjectMilestoneInput!
    ) {
        setProjectMilestone(input: $projectMilestoneInput) {
            warningMessage
            milestones {
                ...recentlyViewedProjectsMilestone
            }
        }
    }
    ${MilestoneFragments.RecentlyViewedProjectsMilestone}
`

export const RemoveProjectMutation = gql`
    mutation($removeProjectInput: RemoveProjectInput!) {
        removeProject(input: $removeProjectInput)
    }
`
export const AddAssociationModifier = gql`
    mutation($associationModifierInput: AssociationModifierInput!) {
        addAssociationModifier(input: $associationModifierInput) {
            name
            associationModifiers {
                name
            }
        }
    }
`
